import React, { useEffect } from 'react';

import {
  WidgetContainer,
  WidgetTitle,
  StyledTable,
  TableHeaderCell,
  TableRowCell,
} from './styles';
import { widgetRoles } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import SecurityTrim from '../../../../services/auth/SecurityTrim';
import { useBeetPriceStore } from '../../../../stores/beetPriceStore';
import { useContextStore } from '../../../../stores/contextStore';

const BeetPriceWidget: React.FC = () => {
  const { t } = useI18n();
  const { beetPrices, getBeetPrices, clearData } = useBeetPriceStore();
  const { activeBpNumber, isAccessOnBehalf } = useContextStore();

  useEffect(() => {
    getBeetPrices();
    return () => {
      clearData();
    };
  }, [getBeetPrices, clearData, activeBpNumber, isAccessOnBehalf]);

  const rowsToDisplay = [...beetPrices]
    .sort((a, b) => b.year - a.year)
    .map((price) => ({
      year: price.year,
      averagePrice: price.averagePrice,
    }));

  return (
    <SecurityTrim requiredBusinessPartnerRoles={widgetRoles}>
      <WidgetContainer>
        <WidgetTitle>{t(TranslationKeys.beetprice_widget_title)}</WidgetTitle>
        <StyledTable>
          <thead>
            <tr>
              <TableHeaderCell>
                {t(TranslationKeys.beetprice_table_header_cell_year)}
              </TableHeaderCell>
              <TableHeaderCell>
                {t(TranslationKeys.beetprice_table_header_cell_price)}
              </TableHeaderCell>
            </tr>
          </thead>
          <tbody>
            {rowsToDisplay.map((row, index) => (
              <tr key={index}>
                <TableRowCell>{row.year}</TableRowCell>
                <TableRowCell>
                  {row.averagePrice !== null
                    ? row.averagePrice.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : ''}
                </TableRowCell>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </WidgetContainer>
    </SecurityTrim>
  );
};

export default BeetPriceWidget;
